"use client";

import React, { useState, useCallback } from "react"; 
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  // CircularProgress,
} from "@mui/material";
import TimedCircularLoader from "../TimedCircularLoader";
import { useRouter, useSearchParams } from "next/navigation";
import { APPLICATION_ID } from "@/constants";

const ShowInstallationModal = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const PARAMS_APPLICATION_ID = searchParams.get(APPLICATION_ID);
  const IS_REDIRECTED = searchParams.get("isRedirected");

  const [isReady, setIsReady] = useState(false); 
  const handleComplete = useCallback(() => setIsReady(true), []);
  if (IS_REDIRECTED === "yes") {
    return (
      <Dialog
        open={true}
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            zIndex: 3000,
            position: "fixed",
            borderRadius: 3,
            px: 1,
            minWidth: 325,
            textAlign: "center",
          },
        }}
        BackdropProps={{
          sx: {
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
            backgroundColor: "rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            fontWeight: 600,
            fontSize: "1.25rem",
            pb: 1,
          }}
        >
          {isReady ? "Installation Complete " : "App Installation is in Progress!"}
        </DialogTitle>

        <DialogContent sx={{ px: 1, pb: 2, width: "100%" }}>
          {!isReady ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center", // vertical
                justifyContent: "center", // horizontal
                minHeight: 200, // optional: gives vertical space
              }}
            >
              <TimedCircularLoader onComplete={handleComplete} /> {/* ✅ passed onComplete */}
            </Box>
          ) : (
            <DialogContentText
              sx={{
                fontSize: "0.95rem",
                color: "text.primary",
                lineHeight: 1.6,
                textAlign: "justify",
              }}
            >
              Now your face will appear on your
              Home Screen.{" "}
              <strong>
                Close your web browser and open the app directly from your Home
                Screen.
              </strong>
            </DialogContentText>
          )}
        </DialogContent>
      </Dialog>
    );
  }

  // page which contain download button
  return <></>;
};

export default ShowInstallationModal;
